export const specialCharRegex = /^(?=.*[!@#$%^&*()"'+\-./:;<=>?@[\\\]^_`{|}~]).{8,50}$/;
export const numberRegex = /^(?=.*\d).{8,50}$/;

export enum PasswordValidationMessage {
  Length = 'This password is too short. It must contain at least 8 characters, please.',
  Number = 'This password must contain at least one number, please.',
  UppercaseLetter = 'This password must contain at least 1 uppercase letter, A-Z, please.',
  SpecialChar = 'This password must contain at least 1 special character, please.'
}
